import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { Icon } from "@/components/common/Icon";
import { cn } from "@/lib/utils";

// Clean editorial vertical block — description + service list. No illustrations.
// tone: "white" | "soft" (alternating section backgrounds).
export const VerticalSection = ({ vertical, tone = "white" }) => (
  <section
    id={vertical.id}
    className={cn("scroll-mt-24 border-t border-border py-20 lg:py-28", tone === "soft" ? "bg-blue-50" : "bg-white")}
    data-testid={`vertical-${vertical.id}`}
  >
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid gap-10 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-16">
        <Reveal>
          <p className="overline">{vertical.short}</p>
          <h2 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-slate-900 md:text-4xl">
            {vertical.name}
          </h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-slate-600">{vertical.description}</p>
          <Link
            to={`/services#${vertical.id}`}
            data-testid={`vertical-link-${vertical.id}`}
            className="group mt-8 inline-flex items-center gap-2 text-sm font-semibold text-slate-900"
          >
            Explore {vertical.short}
            <ArrowRight className="h-4 w-4 text-blue-600 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>

        <Reveal delay={0.08}>
          <ul className="grid grid-cols-1 sm:grid-cols-2 sm:gap-x-10">
            {vertical.services.map((s) => (
              <li key={s.slug} className="border-b border-border">
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`service-link-${s.slug}`}
                  className="group flex items-center gap-3 py-4 text-slate-700 transition-colors duration-200 hover:text-blue-700"
                >
                  <Icon name={s.icon} className="h-4.5 w-4.5 shrink-0 text-blue-600" />
                  <span className="text-[15px] font-medium">{s.name}</span>
                  <ArrowRight className="ml-auto h-4 w-4 -translate-x-1 text-slate-300 opacity-0 transition-all duration-200 group-hover:translate-x-0 group-hover:text-blue-600 group-hover:opacity-100" />
                </Link>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);
